import React, { useState, useEffect, useCallback } from 'react';
import MuiAlert, { AlertProps, type Color } from '@material-ui/lab/Alert';
import {
  Button as ButtonM,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  TextField,
  Typography,
  withStyles,
  Box,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress
} from '@material-ui/core';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../../../services/api';
import { Autocomplete } from '@material-ui/lab';
import {
  capitalFirstLetter,
  maskCPF,
  getFileName,
  sendFileWithoutFake,
  verifyUpLoads
} from '../../../../utils/masks';
import { Guia } from '../../PDF/gerarGuia';
import { PDF } from '../../PDF/gerarPdf';
import { GetApp, Publish, Save, ArrowBack, CheckCircle, Info } from '@material-ui/icons';
import { type AxiosResponse } from 'axios';
import { ASO } from '@data/tipoAso';
import { status } from '@data/status';
import { KitProps } from '@dtos/kitDTO';
import { AppError } from '@utils/AppError';
import { FichaClinica } from '@pages/Agendamentos/PDF/fichaClinica';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getDataScheduling } from '@api/get-data-schedule';
import { LoadingPage } from '@components/LoadingPage';
import { Button } from '@components/Button';
import { postDownloadFicha } from '@api/post-download-ficha';
import { LabelUpload } from './input';
import { Check, Upload } from '@phosphor-icons/react';
import { LinkKitButton } from '@components/LinkKitButton';

interface INomeComercial {
  id_clinicas_credenciadas: number;
  contrato: string;
  nome_comercial: string;
  razao_social: string;
  cpf_cnpj: string;
  dias_funcionamento: string;
  cep: string;
  rua: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  nome_med: string;
  crm: string;
  crm_estado: string;
  trabalho_agendamento: string;
  pagamento_adiantado: string;
  telemedicina: string;
  observacao: string;
}

const ButtonAdd = withStyles(() => ({
  root: {
    background: '#0D9C5B',
    color: '#FFF',
    padding: '10px 30px',
    fontWeight: 'bold',
    border: 'none',
    '&:hover': {
      background: '#0a7e49',
      color: '#FFF',
    },
    '&.Mui-disabled': {
      background: '#cccccc',
      color: '#666666'
    }
  }
}))(ButtonM);

const ButtonSair = withStyles(() => ({
  root: {
    background: '#f44336',
    color: '#FFF',
    padding: '10px 30px',
    fontWeight: 'bold',
    border: 'none',
    '&:hover': {
      background: '#d32f2f',
      color: '#FFF',
    }
  }
}))(ButtonM);

const ButtonDownload = withStyles(() => ({
  root: {
    background: '#1976d2',
    color: '#FFF',
    padding: '10px 20px',
    fontWeight: 'bold',
    border: 'none',
    '&:hover': {
      background: '#1565c0',
      color: '#FFF',
    },
    '&.Mui-disabled': {
      background: '#cccccc',
      color: '#999999'
    }
  }
}))(ButtonM);

const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <Box mt={4} mb={2}>
    <Typography variant="h6" style={{ fontWeight: 'bold', color: '#333', display: 'flex', alignItems: 'center', gap: 8 }}>
      <Info fontSize="small" color="primary" /> {children}
    </Typography>
    <Divider />
  </Box>
);

export const EditNotisTelemedicina: React.FC<any> = (props) => {
  const { id } = useParams<{ id: string }>();
  const { id_agendamento } = props.location.state;

  const [listCredenciado, setListCredenciado] = useState<INomeComercial[]>([]);
  const [selectedNomeComercial, setSelectedNomeComercial] = useState<INomeComercial | null>(null);
  const [searchEmail, setSearchEmail] = useState<any>();
  const [emailAgendamento, setEmailAgendamento] = useState([]);

  const [arquivoSendASO, setArquivoSendASO] = useState<File | string>('');
  const [arquivoProntuario, setArquivoProntuario] = useState<File | string>('');
  const [arquivoASO, setArquivoASO] = useState<File | string>('');
  const [arquivoSendProntuario, setArquivoSendProntuario] = useState<File | string>('');

  const [statusAgendamento, setStatusAgendameto] = useState<string>('');
  const [cpfColab, setCpfColab] = useState<string>('');
  const [nomeColab, setNomeColab] = useState<string>('');
  const [estado, setEstado] = useState<string>('');
  const [cidade, setCidade] = useState<string>('');
  const [dataAgendamento, setDataAgendamento] = useState('');
  const [horarioAgendamento, setHorarioAgendamento] = useState<string>('');
  const [tipoAso, setTipoAso] = useState<string>('');
  const [obs, setObs] = useState<string>('');
  const [nomeComercial, setNomeComercial] = useState<string>('');
  const nome_user = localStorage.getItem('NameUser') || '';
  const [cnpjComercial, setCnpjComercial] = useState('');

  const [snack, setSnack] = useState<boolean>(false);
  const [message, setMessage] = useState('');
  const [cod, setCod] = useState('');
  const [severity, setSeverity] = useState<Color>();
  const [ordemChegada, setOrdemChegada] = useState<string>('');
  const [isLoandingComercialName, setIsLoandingComercialName] = useState(false);

  // Estados para controle de alterações e salvamento
  const [hasChanges, setHasChanges] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false);
  
  // Estados para o modal de download da ficha clínica
  const [openFichaModal, setOpenFichaModal] = useState<boolean>(false);
  const [isDownloadingFicha, setIsDownloadingFicha] = useState<boolean>(false);
  const [hasFichaInDB, setHasFichaInDB] = useState<boolean>(false);
  const [isCheckingFicha, setIsCheckingFicha] = useState<boolean>(false);
  
  // Armazenar os dados originais
  const [originalData, setOriginalData] = useState({
    status: '',
    tipo_aso: '',
    data_agendamento: '',
    horario: '',
    obs: '',
    ordem_chegada: '',
    nome_comercial: '',
    selectedNomeComercial: null as INomeComercial | null,
    arquivo_aso: '',
    arquivo_prontuario: ''
  });

  const {
    data: getDataSchedule,
    isFetching
  } = useQuery({
    queryKey: ['getSchedule', id_agendamento],
    queryFn: () => getDataScheduling(id_agendamento)
  });

  // Função para normalizar o valor do arquivo (tratar "None" como vazio)
  const normalizeArquivo = (valor: string): string => {
    if (!valor || valor === 'None' || valor === 'null' || valor === 'undefined') {
      return '';
    }
    return valor;
  };

  // Função para converter File para string (nome do arquivo)
  const getArquivoNome = (arquivo: File | string): string => {
    if (typeof arquivo === 'string') {
      return normalizeArquivo(arquivo);
    }
    return arquivo.name || '';
  };

  // 1. Nova verificação ultra rápida
  const checkFichaNoBanco = useCallback(async (cpf: string) => {
    setIsCheckingFicha(true);
    try {
      // Ajuste para a nova rota que você criará no Python
      const response = await api.post(`/ravim/check-ficha-existente`, { 
        cpf_colaborador: cpf
      });
      setHasFichaInDB(response.data.exists);
    } catch (err) {
      console.error("Erro ao verificar ficha:", err);
      setHasFichaInDB(false);
    } finally {
      setIsCheckingFicha(false);
    }
  }, []);

  useEffect(() => {
    if (getDataSchedule) {
      setStatusAgendameto(getDataSchedule.status ?? '');
      setCpfColab(getDataSchedule.cpf_colaborador ?? '');
      setNomeColab(getDataSchedule.nome ?? '');
      setDataAgendamento(getDataSchedule.data_agendamento ?? '');
      setHorarioAgendamento(getDataSchedule.horario ?? '');
      setOrdemChegada(getDataSchedule.ordem_chegada ?? '');
      setTipoAso(getDataSchedule.tipo_aso ?? '');
      setObs(getDataSchedule.observacao ?? '');

      let nomeComercialData = null;
      if (getDataSchedule.nome_comercial) {
        nomeComercialData = {
          nome_comercial: getDataSchedule.nome_comercial,
          cpf_cnpj: getDataSchedule.cpf_cnpj_comer,
        } as INomeComercial;
        setSelectedNomeComercial(nomeComercialData);
        setNomeComercial(getDataSchedule.nome_comercial);
        setCnpjComercial(getDataSchedule.cpf_cnpj_comer);
      }
      
      setOriginalData({
        status: getDataSchedule.status ?? '',
        tipo_aso: getDataSchedule.tipo_aso ?? '',
        data_agendamento: getDataSchedule.data_agendamento ?? '',
        horario: getDataSchedule.horario ?? '',
        obs: getDataSchedule.observacao ?? '',
        ordem_chegada: getDataSchedule.ordem_chegada ?? '',
        nome_comercial: getDataSchedule.nome_comercial ?? '',
        selectedNomeComercial: nomeComercialData,
        arquivo_aso: normalizeArquivo(getDataSchedule.arquivo_aso || ''),
        arquivo_prontuario: normalizeArquivo(getDataSchedule.arquivo_prontuario || '')
      });
      
      setIsDataLoaded(true);
      
      if (getDataSchedule.cpf_colaborador) {
        checkFichaNoBanco(getDataSchedule.cpf_colaborador);
      }
    }
  }, [getDataSchedule, checkFichaNoBanco]);

  const canDownloadPreenchida = (): boolean => {
    return hasFichaInDB || hasChanges;
  };

  useEffect(() => {
    if (isDataLoaded) {
      const statusChanged = statusAgendamento !== originalData.status;
      const tipoChanged = tipoAso !== originalData.tipo_aso;
      const dataChanged = dataAgendamento !== originalData.data_agendamento;
      const horarioChanged = horarioAgendamento !== originalData.horario;
      const obsChanged = obs !== originalData.obs;
      const ordemChegadaChanged = ordemChegada !== originalData.ordem_chegada;
      const nomeComercialChanged = nomeComercial !== originalData.nome_comercial;
      const clinicaChanged = JSON.stringify(selectedNomeComercial) !== JSON.stringify(originalData.selectedNomeComercial);
      const arquivoASOChanged = getArquivoNome(arquivoASO) !== originalData.arquivo_aso;
      const arquivoProntuarioChanged = getArquivoNome(arquivoProntuario) !== originalData.arquivo_prontuario;
      
      setHasChanges(statusChanged || tipoChanged || dataChanged || horarioChanged || 
                    obsChanged || ordemChegadaChanged || nomeComercialChanged || clinicaChanged || 
                    arquivoASOChanged || arquivoProntuarioChanged);
    }
  }, [statusAgendamento, tipoAso, dataAgendamento, horarioAgendamento, obs, ordemChegada, nomeComercial, selectedNomeComercial, arquivoASO, arquivoProntuario, originalData, isDataLoaded]);

  useEffect(() => {
    return () => {
      setSelectedNomeComercial(null);
      setListCredenciado([]);
    };
  }, [id_agendamento]);

  async function reqStatus() {
    if (!getDataSchedule) return;
    setIsLoandingComercialName(true);
    try {
      const response = await api.post(`/ravim/telemed-clinicas`, {
        tipo_agendamento: getDataSchedule.tipo_agendamento,
        tipo: getDataSchedule.tipo_agendamento
      });
      if (response.status === 200) setListCredenciado(response.data);
    } catch (err) { console.error(err); } finally { setIsLoandingComercialName(false); }
  }

  function handleClinicaChange(newValue: INomeComercial | null) {
    if (newValue) {
      setSelectedNomeComercial(newValue);
      setNomeComercial(newValue.nome_comercial);
      setCnpjComercial(newValue.cpf_cnpj);
      setSearchEmail(newValue.cpf_cnpj);
      setEstado(newValue.cidade);
      setCidade(newValue.estado);
    } else {
      setSelectedNomeComercial(null);
      setNomeComercial('');
      setCnpjComercial('');
    }
  }

  async function sendAgendamento() {
    setIsSaving(true);
    const data = {
      status: statusAgendamento,
      observacao: obs,
      tipo_aso: tipoAso,
      horario: horarioAgendamento,
      data_agendamento: dataAgendamento,
      estado: estado,
      cidade: cidade,
      nome_comercial: nomeComercial,
      tipo_agendamento: getDataSchedule?.tipo_agendamento,
      nome: nomeColab,
      cpf_colaborador: cpfColab,
      cpf_cnpj_comer: cnpjComercial || getDataSchedule?.cpf_cnpj_comer,
      usuario: `${nome_user} ${new Date().toLocaleString('pt-BR', { hour12: false })}`,
      ordem_chegada: ordemChegada,
      email_agendamento: emailAgendamento,
      arquivo_aso: arquivoASO || getDataSchedule?.arquivo_aso,
      arquivo_prontuario: arquivoProntuario || getDataSchedule?.arquivo_prontuario,
      num_agenda: getDataSchedule?.num_agenda,
      linkDoatendimento: ''
    };

    try {
      const res = await api.post(`/ravim/atualizar-agendamento`, data);
      if (res.status === 200) {
        setSeverity('success');
        setMessage(res.data.message);
        setSnack(true);
        if (arquivoSendProntuario || arquivoSendASO) {
          const formData = new FormData();
          if (arquivoSendProntuario) formData.append('arquivo1', arquivoSendProntuario);
          if (arquivoSendASO) formData.append('arquivo2', arquivoSendASO);
          await api.post(`/file`, formData).catch(console.error);
        }
        setOriginalData({ ...originalData, ...data, arquivo_aso: getArquivoNome(arquivoASO), arquivo_prontuario: getArquivoNome(arquivoProntuario) });
        setHasChanges(false);
        setHasFichaInDB(true);
        setTimeout(() => { setIsSaving(false); window.location.replace('/agendamentos'); }, 2000);
      }
    } catch (err: any) {
      setSeverity('error');
      setMessage(err.message || 'Erro ao salvar');
      setSnack(true);
      setIsSaving(false);
    }
  }

  const { mutateAsync: fetchFichaClinica } = useMutation({
    mutationFn: postDownloadFicha,
    onSuccess: (data) => FichaClinica(data.data),
    onError: (error: any) => { setSeverity('error'); setMessage(error.message); setSnack(true); }
  });

  const reqpdf = useCallback(async (tipo: number, cpf_colab: string, cnpj_comer: string, agenda: string, cnpj_emp: string) => {
    try {
      const res = await api.post(`/ravim/pdf`, { cpf_colaborador: cpf_colab, cnpj_cpf_comer: cnpj_comer, num_agenda: agenda, cnpj_empresa: cnpj_emp });
      tipo === 1 ? Guia(res.data, 'presencial') : PDF(res.data, '');
    } catch (error: any) { setSeverity('error'); setMessage(error.message); setSnack(true); }
  }, []);

  async function downloadFile(arquivo: string) {
    try {
      const res = await api.post(`/ravim/download`, { arquivo });
      const link = document.createElement('a');
      link.href = res.data.dados;
      link.download = arquivo.replace(/[_]/g, ' ');
      link.click();
    } catch (err) { console.error(err); }
  }

  const handleOpenFichaModal = (e: React.MouseEvent) => { e.preventDefault(); e.stopPropagation(); setOpenFichaModal(true); };
  const handleCloseFichaModal = () => setOpenFichaModal(false);

  const handleDownloadFichaPreenchida = async () => {
    if (!getDataSchedule) return;
    setIsDownloadingFicha(true);
    try { await fetchFichaClinica({ cpf_colaborador: getDataSchedule.cpf_colaborador, cnpj_cpf_comer: getDataSchedule.cpf_cnpj_comer, blank: false,num_agenda: getDataSchedule.id_agendamento } as any); handleCloseFichaModal(); }
    catch (error) { console.error('Erro:', error); } finally { setIsDownloadingFicha(false); }
  };

  const handleDownloadFichaEmBranco = async () => {
    if (!getDataSchedule) return;
    setIsDownloadingFicha(true);
    try { await fetchFichaClinica({ cpf_colaborador: getDataSchedule.cpf_colaborador, cnpj_cpf_comer: getDataSchedule.cpf_cnpj_comer, blank: true } as any); handleCloseFichaModal(); }
    catch (error) { console.error('Erro:', error); } finally { setIsDownloadingFicha(false); }
  };

  if (isFetching || !getDataSchedule || !isDataLoaded) return <LoadingPage open={true} onClick={() => { }} />;

  return (
    <Container maxWidth="lg" style={{ paddingTop: 30, paddingBottom: 50 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
        <Typography variant="h4" style={{ fontWeight: 'bold', color: '#1a237e' }}>Editar Agendamento Presencial</Typography>
        <Box display="flex" style={{ gap: 1 }}>
          {verifyUpLoads(getDataSchedule?.arquivo_aso) && <Button title="ASO" icon={<GetApp />} onClick={() => downloadFile(getFileName(getDataSchedule.arquivo_aso))} style={{ minWidth: '150px' }} />}
          {verifyUpLoads(getDataSchedule?.arquivo_prontuario) && <Button title="Prontuário" icon={<GetApp />} onClick={() => downloadFile(getFileName(getDataSchedule.arquivo_prontuario))} style={{ minWidth: '150px' }} />}
          <ButtonM startIcon={<GetApp />} onClick={handleOpenFichaModal} style={{ minWidth: '150px', background: '#C2185B', color: '#FFF', fontWeight: 'bold', padding: '8px 16px', borderRadius: '4px' }} disabled={isSaving}>Ficha Clínica</ButtonM>
          <Button title="Gerar ASO" variantstyle="LIGHT_PINK" icon={<GetApp />} onClick={() => reqpdf(2, getDataSchedule.cpf_colaborador, getDataSchedule.cpf_cnpj_comer, getDataSchedule.num_agenda, getDataSchedule.cnpj_empresa)} style={{ minWidth: '150px' }} disabled={hasChanges || isSaving} />
          <Button title="Gerar Guia" variantstyle="PURPLE" icon={<GetApp />} onClick={() => reqpdf(1, getDataSchedule.cpf_colaborador, getDataSchedule.cpf_cnpj_comer, getDataSchedule.num_agenda, getDataSchedule.cnpj_empresa)} style={{ minWidth: '150px' }} disabled={hasChanges || isSaving} />
        </Box>
      </Box>

      <Dialog open={openFichaModal} onClose={handleCloseFichaModal} maxWidth="sm" fullWidth>
        <DialogTitle style={{ fontWeight: 'bold', color: '#1a237e' }}>Baixar Ficha Clínica</DialogTitle>
        <DialogContent>
          <Box mt={2} mb={2}>
            <Typography variant="body1" gutterBottom>Escolha o formato de download da ficha clínica:</Typography>
            {isCheckingFicha ? (
              <Box display="flex" alignItems="center" style={{ gap: 10 }} mt={2}><CircularProgress size={20} /><Typography variant="caption">Verificando dados no banco...</Typography></Box>
            ) : (
              <Typography variant="caption" color="textSecondary" display="block" >
                {!canDownloadPreenchida() ? 'Atenção: Nenhuma ficha clínica encontrada no banco para este colaborador.' : 'A opção "Ficha em Branco" manterá os dados da Empresa e Colaborador, mas sem as marcações clínicas.'}
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions style={{ padding: '16px', display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <ButtonM onClick={handleCloseFichaModal} style={{ color: '#666' }}>Cancelar</ButtonM>
          <ButtonDownload onClick={handleDownloadFichaEmBranco} disabled={isDownloadingFicha || isCheckingFicha} variant="contained">{isDownloadingFicha ? 'Baixando...' : 'Ficha em Branco'}</ButtonDownload>
          <ButtonDownload onClick={handleDownloadFichaPreenchida} disabled={!canDownloadPreenchida() || isDownloadingFicha || isCheckingFicha} variant="contained">{isDownloadingFicha ? 'Baixando...' : 'Ficha Preenchida'}</ButtonDownload>
        </DialogActions>
      </Dialog>

      <Paper elevation={3} style={{ padding: 30, borderRadius: 12 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <SectionTitle>Arquivos e Documentos</SectionTitle>
            <Box display="flex" style={{ gap: 3 }} p={1}>
              <LabelUpload title="Upload - ASO" variantstyle="DARK_PINK" htmlFor="arquivoASO" icon={arquivoASO ? <CheckCircle color="primary" /> : <Upload />} onChange={(e: any) => { const file = e.target.files[0]; if (file) { setArquivoASO(sendFileWithoutFake(e.target.value)); setArquivoSendASO(file); } }} />
              <LabelUpload title="Upload - Prontuário" variantstyle="LIGHT_PINK" htmlFor="arquivoProntuario" icon={arquivoProntuario ? <CheckCircle color="primary" /> : <Upload />} onChange={(e: any) => { const file = e.target.files[0]; if (file) { setArquivoProntuario(sendFileWithoutFake(e.target.value)); setArquivoSendProntuario(file); } }} />
            </Box>
            <SectionTitle>Informações do Colaborador</SectionTitle>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}><TextField label="CPF" disabled variant="outlined" fullWidth value={cpfColab} /></Grid>
              <Grid item xs={12} sm={8}><TextField label="Nome Completo" disabled variant="outlined" fullWidth value={nomeColab} /></Grid>
            </Grid>
            <SectionTitle>Dados do Atendimento</SectionTitle>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}><FormControl variant="outlined" fullWidth><InputLabel>Status do Agendamento</InputLabel><Select label="Status do Agendamento" value={statusAgendamento} onChange={(e: any) => setStatusAgendameto(e.target.value)}>{status.map((s, i) => <MenuItem key={i} value={s.value}>{s.value}</MenuItem>)}</Select></FormControl></Grid>
              <Grid item xs={12} sm={6}><FormControl variant="outlined" fullWidth><InputLabel>Tipo de ASO</InputLabel><Select label="Tipo de ASO" value={tipoAso} onChange={(e: any) => setTipoAso(e.target.value)}>{ASO.map((a, i) => <MenuItem key={i} value={a.value}>{a.value}</MenuItem>)}</Select></FormControl></Grid>
              <Grid item xs={12}><Autocomplete id="clinica-autocomplete" options={listCredenciado} getOptionLabel={(option) => option.nome_comercial || ""} value={selectedNomeComercial} onChange={(_, newValue) => handleClinicaChange(newValue)} onOpen={() => listCredenciado.length === 0 && reqStatus()} loading={isLoandingComercialName} renderInput={(params) => (<TextField {...params} variant="outlined" label="Clínica Credenciada" placeholder="Pesquisar clínica..." />)} fullWidth /></Grid>
              <Grid item xs={12} sm={4}><TextField label="Data" variant="outlined" type="date" fullWidth InputLabelProps={{ shrink: true }} value={dataAgendamento} onChange={(e) => setDataAgendamento(e.target.value)} /></Grid>
              <Grid item xs={12} sm={4}><TextField label="Horário" variant="outlined" type="time" fullWidth InputLabelProps={{ shrink: true }} value={horarioAgendamento} onChange={(e) => setHorarioAgendamento(e.target.value)} disabled={ordemChegada === 'Sim'} /></Grid>
              <Grid item xs={12} sm={4}><Box border={1} borderColor="#ccc" borderRadius={4} p={1}><Typography variant="caption" color="textSecondary">Ordem de Chegada?</Typography><RadioGroup row value={ordemChegada} onChange={(e) => setOrdemChegada(e.target.value)}><FormControlLabel value="Sim" control={<Radio color="primary" />} label="Sim" /><FormControlLabel value="Não" control={<Radio color="primary" />} label="Não" /></RadioGroup></Box></Grid>
              <Grid item xs={12}><TextField label="Observações" multiline minRows={3} variant="outlined" fullWidth value={obs} onChange={(e) => setObs(e.target.value)} /></Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <Box display="flex" justifyContent="flex-start" alignItems="center" style={{ gap: 2 }} mt={4}>{getDataSchedule?.token_kit && (<LinkKitButton token_kit={getDataSchedule.token_kit} id_agendamento={getDataSchedule.id_agendamento} data_agendamento={getDataSchedule.data_agendamento} />)}</Box>
      <Box display="flex" justifyContent="flex-end" alignItems="center" style={{ gap: 2 }} mt={-7}><Link to="/agendamentos" style={{ textDecoration: 'none' }}><ButtonSair startIcon={<ArrowBack />} style={{ minWidth: '150px', minHeight: '51px' }}>Sair sem Salvar</ButtonSair></Link><ButtonAdd startIcon={<Save />} onClick={sendAgendamento} style={{ minWidth: '150px', minHeight: '51px' }} disabled={!hasChanges || isSaving}>{isSaving ? 'Salvando...' : 'Salvar Alterações'}</ButtonAdd></Box>
      <Snackbar open={snack} autoHideDuration={4000} onClose={() => setSnack(false)}><MuiAlert severity={severity} variant="filled" elevation={6}>{message}</MuiAlert></Snackbar>
    </Container>
  );
};
